# WHERE THE SUPPORT CHAT WIDGET LIVES, and where it does NOT.
#
# This file used to mount it (initAgentView, right beside Mixpanel). The
# widget is not a tracker: it is how a signed-in parent reaches support. An
# instance that turns third-party tracking off (DISABLE_THIRD_PARTY_TRACKING
# -> window.config.donotinitthirdparty) therefore lost its support chat with
# it, and on QA the widget could not be reached in the app at all
# (card 6aa8b5f050645cd1c3e765bc). loopback_api.coffee now mounts it on its
# own path. All this file still owns is WHICH SERVER hosts the widget app,
# which is the one thing that genuinely differs between the two builds.
export AGENT_WIDGET_SERVER = 'https://elfeet.bigmathlearning.com'


export default init = () ->
  # on webflow, this is sometimes run more than once
  if window.third_party_initted
    console.warn "Duplicate third party init ignored."
    return
  window.third_party_initted = true

  # mark that we are using production tracking (for GTM)
  window.config.developmentTracking = false

  # initialize mixpanel
  ((e, a) ->
    if !a.__SV
      b = window
      try
        c = undefined
        l = undefined
        i = undefined
        j = b.location
        g = j.hash

        c = (a, b) ->
          if (l = a.match(RegExp(b + '=([^&]*)'))) then l[1] else null

        g and c(g, 'state') and i = JSON.parse(decodeURIComponent(c(g, 'state')))
        'mpeditor' == i.action and b.sessionStorage.setItem('_mpcehash', g)
        history.replaceState(i.desiredHash or '', e.title, j.pathname + j.search)

      catch m
      k = undefined
      h = undefined
      window.mixpanel = a
      a._i = []

      a.init = (b, c, f) ->
        `var e`
        d = a

        e = (b, a) ->
          `var c`
          c = a.split('.')
          2 == c.length and b = b[c[0]]
          a = c[1]

          b[a] = ->
            b.push [ a ].concat(Array::slice.call(arguments, 0))
            return

          return

        if 'undefined' != typeof f then (d = a[f] = []) else (f = 'mixpanel')
        d.people = d.people or []

        d.toString = (b) ->
          `var a`
          a = 'mixpanel'
          'mixpanel' != f and (a += '.' + f)
          b or (a += ' (stub)')
          a

        d.people.toString = ->
          d.toString(1) + '.people (stub)'

        k = 'disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user'.split(' ')
        h = 0
        while h < k.length
          e d, k[h]
          h++
        a._i.push [
          b
          c
          f
        ]
        return

      a.__SV = 1.2
      b = e.createElement('script')
      b.type = 'text/javascript'
      b.async = !0
      b.src = if 'undefined' != typeof MIXPANEL_CUSTOM_LIB_URL then MIXPANEL_CUSTOM_LIB_URL else if 'file:' == e.location.protocol and '//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js'.match(/^\/\//) then 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js' else '//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js'
      c = e.getElementsByTagName('script')[0]
      c.parentNode.insertBefore b, c
    return
  ) document, window.mixpanel or []
  mixpanel.init '67fbf9c655fb28e10ef992be2a2c1236'


  # attach pinterest
  `!function(e){if(!window.pintrk){window.pintrk = function () {
  window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
      n=window.pintrk;n.queue=[],n.version="3.0";var
      t=document.createElement("script");t.async=!0,t.src=e;var
      r=document.getElementsByTagName("script")[0];
      r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
  `
  # No `em` (card 6a811425b4eb4d026638b9de). This carried Pinterest's own
  # install-doc placeholder, the literal string '<user_email_address>', which
  # was sent as the enhanced-match email on every production pageload — a
  # constant bogus identifier polluting the account and degrading match rates.
  # Removal is the honest fix rather than substitution: this runs at init, when
  # no user email is available yet. If enhanced match is wanted later it is a
  # pintrk('set', {em: ...}) once a real address is known.
  pintrk('load', '2617750729731');
  pintrk('page');

  # attach google tag manager
  `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-MKCMZ22');`

